import InfoLabel from '@/components/InfoLabel';
import Tip from '@/components/Tip/Tip';
import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Button,
    FormControl,
    FormErrorMessage,
    Heading,
    Input,
    InputGroup,
    InputLeftAddon,
    useToast,
} from '@chakra-ui/react';
import { UseFormReturn } from 'react-hook-form';

import IRootPage from '@/types/IRootPage';
import { useTranslation } from 'react-i18next';

interface IProps {
	rootPage: IRootPage;
	isLoading: boolean;
	form: UseFormReturn<IRootPage>;
	submitForm: () => void;
}

export default function SectionShare(props: IProps) {
	const { t } = useTranslation();
	const toast = useToast();

	function handleShareClick() {
		const publicUrl = window.location.origin + '/rp/' + props.rootPage.slug;
		navigator.clipboard.writeText(publicUrl);
		toast({ isClosable: true,
			title: t('Link group url copied to clipboard'),
			description: t('You can now share it with your clients.'),
			status: 'success',
		});
	}

	return (
		<Accordion allowToggle mt="2" background="white" borderRadius="md" borderColor="gray.100" borderWidth={1}>
			<AccordionItem overflow="hidden" borderRadius="md" border="none">
				<AccordionButton>
					<Heading as="h2" size="sm" p="4">
						{t('Share')}
					</Heading>
					<AccordionIcon ml="auto" />
				</AccordionButton>
				<AccordionPanel p={4} borderTopWidth={1} borderTopColor="gray.100" borderTopStyle="solid">
					<Tip>
						{t('Share the link group with your clients so they can see all your reservation calendars linked in a single page.')}
					</Tip>

					<FormControl id="slug" mt="4" isInvalid={!!props.form.formState.errors?.slug} isDisabled={props.isLoading}>
						<InfoLabel text={t('Link group url')} help={t('Share this url to let people see your link group.')} />
						<InputGroup>
							<InputLeftAddon fontSize="sm">{window.location.origin + '/rp/'}</InputLeftAddon>
							<Input fontSize="sm" {...props.form.register('slug')} type="text" onBlur={props.submitForm} />
						</InputGroup>
						<FormErrorMessage>{t((props.form.formState.errors?.slug || '') as string)}</FormErrorMessage>
					</FormControl>

					<Button mt={8} colorScheme="primary" w="100%" onClick={handleShareClick}>
						{t('Share link group')}
					</Button>
				</AccordionPanel>
			</AccordionItem>
		</Accordion>
	);
}
